import React from 'react';
import { Popover } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { getEstimatedBadgeTooltip, PRODUCTS_EDIT_DEFAULTS_PATH } from './estimatedBadgeContent';
import { appTooltipTypography } from '../../theme/appTooltipTypography';
import {
    EstimatedBadgeIcon,
    EstimatedBadgeRoot,
    EstimatedBadgeText,
    PopoverBody,
    PopoverContent,
    PopoverDivider,
    PopoverLink,
    PopoverTitle,
    PopoverTitleIcon,
} from './EstimatedBadge.style';

const POPOVER_STYLES = {
    body: {
        ...appTooltipTypography,
        backgroundColor: '#1e293b',
        borderRadius: 12,
        padding: '12px 14px',
        boxShadow: '0 12px 32px rgba(15, 23, 42, 0.35)',
    },
};

function EstimatedBadgePopoverContent({ metricKey }) {
    const { title, body } = getEstimatedBadgeTooltip(metricKey);

    return (
        <PopoverContent className="estimated-badge-popover__content">
            <PopoverTitle>
                <PopoverTitleIcon aria-hidden>⚡</PopoverTitleIcon>
                {title}
            </PopoverTitle>
            <PopoverBody>{body}</PopoverBody>
            <PopoverDivider />
            <PopoverLink
                to={PRODUCTS_EDIT_DEFAULTS_PATH}
                onMouseDown={(e) => e.preventDefault()}
            >
                Edit smart defaults on Products
                <RightOutlined style={{ fontSize: 10 }} />
            </PopoverLink>
        </PopoverContent>
    );
}

/**
 * Compact pill badge for smart-default / estimated metrics.
 * variant="est" → ⚡ EST.
 * variant="default" → ⚡ 30%
 */
export default function EstimatedBadge({
    variant = 'est',
    value,
    className = '',
    metricKey,
    showPopover = true,
}) {
    const text = variant === 'default' && value ? value : 'EST.';

    const badge = (
        <EstimatedBadgeRoot
            className={className}
            $interactive={showPopover && !!metricKey}
            tabIndex={showPopover && metricKey ? 0 : undefined}
            onClick={(e) => e.stopPropagation()}
        >
            <EstimatedBadgeIcon aria-hidden>⚡</EstimatedBadgeIcon>
            <EstimatedBadgeText>{text}</EstimatedBadgeText>
        </EstimatedBadgeRoot>
    );

    if (!showPopover || !metricKey) {
        return badge;
    }

    return (
        <Popover
            classNames={{ root: 'estimated-badge-popover' }}
            styles={POPOVER_STYLES}
            color="#1e293b"
            content={<EstimatedBadgePopoverContent metricKey={metricKey} />}
            trigger={['hover', 'click']}
            placement="bottom"
            mouseEnterDelay={0.15}
            mouseLeaveDelay={0.1}
            destroyTooltipOnHide
        >
            {badge}
        </Popover>
    );
}
